module.exports = {
      id: "toast-error-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-3bd5c44086b3ee01fb1a36f6e1306c3d.svg#toast-error",
      toString: function () {
        return this.url;
      }
    }